"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Badge_1 = __importDefault(require("components/shared/Badge"));
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const HelperUtils_1 = require("utils/HelperUtils");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const FilterCount = ({ filterKey }) => {
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)(state => state.filter, (oldState, newState) => {
        // prevent rerender if the changes is not related to current filterKey
        return (0, isEqual_1.default)(oldState[id][filterKey], newState[id][filterKey]);
    });
    return filter[id]?.[filterKey]?.length > 0 ? (react_1.default.createElement(Badge_1.default, { content: filter[id]?.[filterKey]?.length || 0, colorHex: (0, HelperUtils_1.getCssVariableValue)('--base-600'), bgColorHex: (0, HelperUtils_1.getCssVariableValue)('--base-200') })) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = (0, react_1.memo)(FilterCount);
